import React from 'react';
import { portfolioData } from '../data/portfolio';

const BuiltBy = () => {
  const { profile } = portfolioData;
  const currentYear = new Date().getFullYear();

  return (
    <section className="py-12 px-6">
      <div className="max-w-7xl mx-auto text-center">
        <p className="text-[#666666] text-sm">
          Built and designed by <span className="text-[#00b4d8] font-medium">{profile.name}</span>
        </p>
        <p className="text-[#666666] text-xs mt-2">
          © {currentYear} All rights reserved.
        </p>
      </div>
    </section>
  );
};

export default BuiltBy;
